












































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import {Table} from '@/components/bwaff';

@Component({
  components: {
    DataTable: Table,
}})
export default class ChangePlanDetails extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop()
  plan: Billing.BillingPlan;

  @Prop()
  handlePlanSelect;

  get tableRows() {
    const { usage } = this.$store.state.billing;
    const { limits } = this.plan

    return Object.keys(usage).reduce((acc,key)=> {
      if (+usage[key] > +limits[key]) {
        acc.push({
          elements: this.planLimitsKeyTextShort[key],
          current_amount: usage[key],
          new_plan_limits: limits[key]
        })
      }
      
      return acc
    },[])
  }

  get headers() {
    return [
      {
        text: this.t('Elements/ Options'),
        align: 'left',
        sortable: false,
        value: 'elements'
      },

      {
        text: this.t('Current Amount'),
        align: 'center',
        value: 'current_amount',
        sortable: false
      },
      {
        text: this.t('New Plan Limits'),
        align: 'center',
        value: 'new_plan_limits',
        sortable: false
      }
    ];
  }
  
}
